import { JOBS } from "./catalog";
import { formatSiNumber } from "../seo/formatPublished";

function publishedNumber(value, unit) {
  if (value === null || value === undefined) return null;
  return `${formatSiNumber(value)} ${unit}`;
}

function publishedList(values) {
  if (!Array.isArray(values) || values.length === 0) return null;
  return values.join(", ");
}

function footprintText(footprint) {
  if (!footprint) return null;
  const parts = [];
  if (footprint.l != null) parts.push(`L ${formatSiNumber(footprint.l)} mm`);
  if (footprint.w != null) parts.push(`W ${formatSiNumber(footprint.w)} mm`);
  if (footprint.h != null) parts.push(`H ${formatSiNumber(footprint.h)} mm`);
  return parts.length ? parts.join(", ") : null;
}

function jobLabels(robot) {
  return robot.jobs
    .map((slug) => JOBS.find((job) => job.slug === slug)?.label || slug)
    .join(", ");
}

export function cardStats(robot) {
  return [
    { label: "Payload", value: robot.payloadKg, unit: "kg" },
    { label: "Lift height", value: robot.liftHeightMm, unit: "mm" },
    { label: "Top speed", value: robot.maxSpeedMs, unit: "m/s" },
    { label: "Minimum aisle", value: robot.minAisleMm, unit: "mm" },
  ];
}

export function specRows(robot) {
  const battery = robot.battery || {};
  const rows = [
    ["Type", robot.typeLabel],
    ["Payload", publishedNumber(robot.payloadKg, "kg")],
    ["Lift height", publishedNumber(robot.liftHeightMm, "mm")],
    ["Lift height options", robot.liftHeightOptionsMm?.length
      ? `${robot.liftHeightOptionsMm.map((value) => formatSiNumber(value)).join(", ")} mm`
      : null],
    ["Footprint", footprintText(robot.footprintMm)],
    ["Weight", publishedNumber(robot.weightKg, "kg")],
    ["Top speed", publishedNumber(robot.maxSpeedMs, "m/s")],
    ["Turning radius", publishedNumber(robot.turningRadiusMm, "mm")],
    ["Rotation diameter", publishedNumber(robot.rotationDiameterMm, "mm")],
    ["Minimum aisle", publishedNumber(robot.minAisleMm, "mm")],
    ["Ground clearance", publishedNumber(robot.groundClearanceMm, "mm")],
    ["Navigation", publishedList(robot.navigation)],
    ["Positioning accuracy", publishedNumber(robot.positioningAccuracyMm, "mm")],
    ["Battery chemistry", battery.chemistry],
    ["Battery voltage", publishedNumber(battery.voltageV, "V")],
    ["Battery capacity", publishedNumber(battery.capacityAh, "Ah")],
    ["Runtime", publishedNumber(battery.runtimeHours, "hours")],
    ["Charge strategy", publishedList(battery.chargeStrategy)],
    ["Charge time", publishedNumber(battery.chargeTimeMinutes, "minutes")],
    ["Fleet software", publishedList(robot.fleetSoftware)],
    ["VDA 5050", robot.vda5050 === null || robot.vda5050 === undefined
      ? null
      : robot.vda5050 ? "Yes" : "No"],
    ["Environment", robot.environment],
    ["IP rating", robot.ipRating],
    ["Jobs", jobLabels(robot)],
  ];

  return rows
    .filter(([, value]) => value !== null && value !== undefined && value !== "")
    .map(([label, value]) => ({ label, value }));
}
